// src/locales/si/productTags.js
export const productTags = {
  // Page titles and descriptions
  title: "නිෂ්පාදන ටැග්",
  description: "ඔබේ නිෂ්පාදන ඵලදායී ලෙස සංවිධානය හා වර්ගීකරණය කිරීම සඳහා නිෂ්පාදන ටැග් කළමනාකරණය කරන්න",
  
  // Navigation
  addTag: "ටැගය එක් කරන්න",
  createNewTag: "නව ටැගයක් සාදන්න",
  editTag: "ටැගය සංස්කරණය කරන්න",
  createFirstTag: "පළමු ටැගය සාදන්න",
  
  // Form Fields
  tagName: "ටැග් නාමය",
  tagNamePlaceholder: "ටැග් නාමය ඇතුළත් කරන්න (උදා: නව පැමිණීම, හොඳම විකුණුම, අලෙවිය)",
  
  // Table Headers
  name: "නම",
  createdAt: "නිර්මාණය",
  updatedAt: "අවසන් යාවත්කාලීනය",
  
  // Search and Filter
  searchTags: "නම අනුව ටැග් සොයන්න...",
  filteredResults: "ටැග් {{total}} න් {{count}}",
  totalTags: "ටැග් {{count}}",
  
  // Validation Messages
  nameRequired: "ටැග් නාමය අවශ්‍යයි",
  nameMinLength: "ටැග් නාමය අවම වශයෙන් අක්ෂර 2ක් විය යුතුයි",
  nameMaxLength: "ටැග් නාමය අක්ෂර 50 ඉක්මවිය නොහැක",
  
  // Actions
  createTag: "ටැගය සාදන්න",
  updateTag: "ටැගය යාවත්කාලීන කරන්න",
  saveChanges: "වෙනස්කම් සුරකින්න",
  
  // Success/Error Messages
  tagCreatedSuccess: "'{{tagName}}' ටැගය සාර්ථකව සාදන ලදී!",
  tagUpdatedSuccess: "'{{tagName}}' ටැගය සාර්ථකව යාවත්කාලීන කරන ලදී!",
  tagDeletedSuccess: "'{{tagName}}' ටැගය සාර්ථකව මකා දමා ඇත.",
  failedToCreate: "ටැගය සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToUpdate: "ටැගය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToDelete: "ටැගය මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToLoadTag: "ටැග් විස්තර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToLoadTags: "ටැග් පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  
  // Loading states
  loadingTags: "ටැග් පූරණය වෙමින්...",
  loadingTagsDesc: "කරුණාකර අපි ඔබේ නිෂ්පාදන ටැග් ලබා ගන්නා තෙක් රැඳී සිටින්න.",
  savingTag: "ටැගය සුරකිමින්...",
  deletingTag: "ටැගය මකමින්...",
  
  // Empty states
  noTags: "තවම ටැග් නැත",
  noTagsDesc: "ලේබල් සහ කාණ්ඩ සමඟ ඔබේ නිෂ්පාදන සංවිධානය කිරීම ආරම්භ කිරීමට ඔබේ පළමු නිෂ්පාදන ටැගය සාදන්න.",
  noSearchResults: "ටැග් හමු නොවීය",
  noSearchResultsDesc: "ඔබේ සෙවුම් පද සකස් කිරීමට උත්සාහ කරන්න හෝ සියලුම ටැග් බැලීමට පෙරහන් ඉවත් කරන්න.",
  
  // Confirmation dialogs
  confirmDelete: "ඔබට විශ්වාසද '{{tagName}}' ටැගය මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැකි අතර මෙම ටැගය භාවිතා කරන නිෂ්පාදන වලට බලපෑ හැකිය.",
  confirmDeleteTitle: "ටැගය මකන්න",
  
  // Status and metadata
  createdDate: "{{date}} දින නිර්මාණය කරන ලදී",
  updatedDate: "අවසන් වරට {{date}} දින යාවත්කාලීන කරන ලදී",
  businessTag: "ව්‍යාපාර ටැගය",
  
  // Form validation hints
  nameHint: "ඔබේ නිෂ්පාදන වර්ගීකරණය කිරීමට උපකාරී විස්තරාත්මක නම් භාවිතා කරන්න (උදා: 'සෘතුමය', 'විශේෂාංග', 'නිෂ්කාශනය')",
  duplicateNameError: "මෙම නමින් ටැගයක් දැනටමත් පවතී",
  
  // Sorting
  sortBy: "අනුපිළිවෙල",
  sortByName: "නම",
  sortByCreated: "නිර්මාණ දිනය",
  sortByUpdated: "යාවත්කාලීන දිනය",
  ascending: "ආරෝහණ",
  descending: "අවරෝහණ"
};